module.exports = __webpack_public_path__ + "img/2.93ff4d73.png";